import { ISite, ISiteEquipment } from 'shared/api/api';
import { OwnerFields, SiteFields } from './create-site-context-provider';
import { Option } from 'react-dropdown';
import ObjectID from 'bson-objectid';
export const MapCreateSiteFormValuesToSite = (
	ownerFields: OwnerFields,
	siteFields: SiteFields,
	processEquipmentFields?: Partial<ISiteEquipment>,
): ISite => {
	const site: ISite = {
		id: new ObjectID().toHexString(),
		siteName: siteFields.name,
		siteAddress: siteFields.addresse,
		siteCity: siteFields.city,
		siteZipCode: Number(siteFields.postNr) || 0,
		chRnum: Number(siteFields.chrNr) || 0,
		countryId: siteFields.country,

		ownerName: ownerFields.name,
		ownerAddress: ownerFields.address,
		ownerCity: ownerFields.city,
		ownerZipCode: Number(ownerFields.postNumber) || 0,
		cvRnum: Number(ownerFields.cvrNr) || 0,

		deviceId: processEquipmentFields?.code,

		default: false,
		isDeleted: false,
		latestMessageTimestamp: new Date(),
	};

	return site;
};

export const generateTimeZoneOptions = (locales?: string): Option[] =>
	// Casting Intl to any cause it does not have typescript docs
	(Intl as any).supportedValuesOf('timeZone').map(tz => {
		const offset = new Intl.DateTimeFormat(locales ?? 'en', { timeZone: tz, timeZoneName: 'shortOffset' })
			.formatToParts(new Date())
			.find(p => p.type === 'timeZoneName')?.value;
		return { label: `(${offset}) ${tz}`, value: tz };
	});

// Timezone list docs.
//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/supportedValuesOf
